/**
 * buildTexData — extracts the data object that feeds generateTex.
 * Takes the destructured useResume() context object and returns the
 * exact same structure that FinalResumePage previously assembled inline.
 *
 * @param {object} ctx  — the object destructured from useResume()
 * @returns {object}    — data object accepted by generateTex(data, opts)
 */
export function buildTexData(ctx) {
    const {
        contact,
        contactToggles,
        summary,
        skills,
        experiences,
        educations,
        projects,
        awards,
        certifications,
    } = ctx;

    return {
        contact,
        contactToggles,
        summary,
        skills,
        experiences,
        educations,
        projects,
        awards,
        certifications,
    };
}
